import { styled as o } from "@mui/material";
import c from "../../temp-lib/components/share/popup/InfoPopup.js";
import { INFO_POPUP_TYPE as d } from "../../temp-lib/constants/popup.js";
import u from "./TokenSection.js";
import { useTranslation as h } from "react-i18next";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
const f = o(c)`
  height: auto;
  max-height: 95%;
  max-width: 1280px;
  width: 95%;

  .Custom-Content {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 10px;
  }
`, i = o(u)`
  ${(t) => t.theme.breakpoints.down("res768")} {
    .Custom-Token-Box {
      display: grid;
      grid-template-columns: repeat(2, minmax(50px, 1fr));
      grid-row-gap: 16px;
      .Custom-Token:last-child {
        border-right: unset;
        padding-right: unset;
      }
      .Custom-Token:nth-of-type(even) {
        border-right: unset;
        margin-left: auto;
        padding-right: unset;
      }
    }
  }
`, g = o(i)`
  .Custom-Title {
    color: #6eeae6;
  }
  width: 100%;
`, x = o(i)`
  .Custom-Title {
    color: #90ffd5;
  }
  width: 100%;
`, S = (t) => {
  const {
    className: r,
    offChainTokens: s,
    onChainTokens: a,
    open: p,
    onClose: m
  } = t, {
    t: n
  } = h();
  return /* @__PURE__ */ l(f, {
    className: r,
    open: p,
    type: d.BLACK,
    onClose: m,
    children: [/* @__PURE__ */ e(x, {
      onChain: !0,
      title: n("currency_group.onchain"),
      tokens: a
    }), /* @__PURE__ */ e(g, {
      title: n("currency_group.offchain"),
      tokens: s
    })]
  });
};
export {
  S as default
};
//# sourceMappingURL=TokenSectionPopup.js.map
